<template>
  <v-card color="green lighten-2" dark="dark" hover="hover" to="/location">
    <v-card-text style="height: 128px;">
      <v-layout align-center justify-center column fill-height>
        <animated-number
          class="display-1 font-weight-light"
          v-if="currentOrganization.Stores"
          :value="currentOrganization.Stores.length"
          :formatValue="formatToNumber"
          :duration="1000"
        >
        </animated-number>
        <animated-number
          class="display-1 font-weight-light"
          v-else
          :value="0"
          :formatValue="formatToNumber"
          :duration="1000"
        >
        </animated-number>
        <div class="text-center body-1">{{ $t("labels.stores") }}</div>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import AnimatedNumber from "animated-number-vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      activeStore: 0,
      isLoading: true
    };
  },
  methods: {
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    }
  },
  components: {
    AnimatedNumber
  },
  computed: {
    ...mapGetters("global", ["currentOrganization", "currentUser", "organizationList"])
  }
};
</script>

<style scoped></style>
